import LoyaltyTierPill from 'components/Luxkit/LoyaltyTierPill'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import { useAppSelector } from 'hooks/reduxHooks'
import { LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL } from 'loyalty/constants/loyaltyBonusPoints'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import React from 'react'

interface Props {
  campaignType: App.LoyaltyBonusPointsCampaignType
}

function LoyaltyBonusPointsInfoSheet({ campaignType }: Props) {
  const tier = useAppSelector(getLoyaltyDisplayTier)

  return <Sheet background={`tier-${tier}-light`} padding={16}>
    <Group direction="vertical" tabletDirection="horizontal" verticalAlign="center" gap={12}>
      <LoyaltyTierPill variant="primary" tier={tier}>{LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL[campaignType]}</LoyaltyTierPill>
      <BodyText variant="small" weight="bold">
        This offer includes a limited-time bonus points special.
      </BodyText>
    </Group>
  </Sheet>
}

export default LoyaltyBonusPointsInfoSheet
